import { Link } from 'react-router-dom';

interface RelatedArticle {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryColor: string;
  readTime: string;
  image: string;
}

// Master article data map — used for all Related Articles strips across newer blog posts
const ARTICLE_DATA: Record<string, RelatedArticle> = {
  'how-much-life-insurance-indiana': {
    slug: 'how-much-life-insurance-indiana',
    title: 'How Much Life Insurance Do I Need in Indiana?',
    excerpt: 'DIME method calculator with Indiana-specific mortgage, income, and education cost data. Takes 2 minutes.',
    category: 'Coverage Planning',
    categoryColor: 'bg-[#1A3A52] text-white',
    readTime: '10 min read',
    image: 'https://public.readdy.ai/ai/img_res/8828ecd7d486275744d7067d7f9ec4a2.jpg',
  },
  'cheapest-life-insurance-indiana': {
    slug: 'cheapest-life-insurance-indiana',
    title: 'Cheapest Life Insurance in Indiana: How Hoosiers Save',
    excerpt: 'Real carrier rate comparison, 6 proven cost-cutting strategies, and the lowest-priced policies for every age group.',
    category: 'Term Life',
    categoryColor: 'bg-[#D97642] text-white',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=smiling%20Indiana%20couple%20reviewing%20affordable%20life%20insurance%20rates%20on%20laptop%20bright%20modern%20home%20desk%20savings%20clean%20white%20minimal%20background&width=600&height=380&seq=related-cheapest&orientation=landscape',
  },
  'life-insurance-for-families-indianapolis': {
    slug: 'life-insurance-for-families-indianapolis',
    title: 'Best Life Insurance for Indianapolis Families',
    excerpt: 'Coverage amounts, best policy types, and real 2025 pricing for every family stage — newlyweds to empty nesters.',
    category: 'Family Coverage',
    categoryColor: 'bg-emerald-600 text-white',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=happy%20Indianapolis%20family%20of%20four%20at%20home%20parents%20and%20two%20young%20children%20smiling%20bright%20living%20room%20clean%20modern%20warm%20natural%20light%20insurance%20planning&width=600&height=380&seq=related-families&orientation=landscape',
  },
  'life-insurance-quotes-indiana': {
    slug: 'life-insurance-quotes-indiana',
    title: 'Life Insurance Quotes Indiana: Get Accurate Rates',
    excerpt: 'What determines your Indiana quote, real pricing by age and health class, and how to compare 10+ carriers side-by-side.',
    category: 'Term Life',
    categoryColor: 'bg-[#D97642] text-white',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Indiana%20insurance%20agent%20comparing%20life%20insurance%20quotes%20on%20computer%20screen%20bright%20professional%20office%20Indianapolis%20clean%20minimal%20background%20showing%20rate%20comparison%20charts&width=600&height=380&seq=related-quotes&orientation=landscape',
  },
  'life-insurance-indiana-seniors': {
    slug: 'life-insurance-indiana-seniors',
    title: 'Life Insurance for Seniors in Indiana (2025)',
    excerpt: 'Final expense, guaranteed issue, and term life compared with real rates for ages 60–85. No-exam options available.',
    category: 'Senior Coverage',
    categoryColor: 'bg-amber-600 text-white',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=active%20senior%20couple%20in%20their%2060s%20smiling%20outdoors%20Indiana%20park%20autumn%20leaves%20golden%20hour%20warm%20light%20healthy%20retired%20lifestyle%20cheerful%20clean%20blurred%20background&width=600&height=380&seq=related-seniors&orientation=landscape',
  },
  'no-medical-exam-life-insurance-indiana': {
    slug: 'no-medical-exam-life-insurance-indiana',
    title: 'No Medical Exam Life Insurance Indiana',
    excerpt: 'Simplified issue vs. guaranteed issue compared. Same-day approval available — no blood draw, no doctor visit.',
    category: 'No Exam',
    categoryColor: 'bg-emerald-600 text-white',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=relaxed%20Indiana%20man%20completing%20life%20insurance%20application%20on%20laptop%20at%20bright%20home%20office%20clean%20white%20minimal%20background%20no%20stress%20easy%20approval%20warm%20natural%20light&width=600&height=380&seq=related-noexam&orientation=landscape',
  },
  'life-insurance-self-employed-indiana': {
    slug: 'life-insurance-self-employed-indiana',
    title: 'Life Insurance for Self-Employed Indiana',
    excerpt: 'Why 1099 workers need more coverage than W-2 employees, plus the best policy types and tax strategy for business owners.',
    category: 'Self-Employed',
    categoryColor: 'bg-[#1A3A52] text-white',
    readTime: '12 min read',
    image: 'https://readdy.ai/api/search-image?query=self%20employed%20Indiana%20small%20business%20owner%20entrepreneur%20reviewing%20life%20insurance%20documents%20at%20modern%20home%20office%20desk%20laptop%20coffee%20clean%20bright%20minimal%20background%20professional%20focused&width=600&height=380&seq=related-selfemployed&orientation=landscape',
  },
  'burial-insurance-indiana': {
    slug: 'burial-insurance-indiana',
    title: 'Burial Insurance Indiana: Costs & Best Plans',
    excerpt: 'Real rates by age for $10K–$25K policies, top carriers, guaranteed approval options, and 5 costly mistakes to avoid.',
    category: 'Final Expense',
    categoryColor: 'bg-amber-600 text-white',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=dignified%20senior%20Indiana%20couple%20in%20their%2070s%20reviewing%20burial%20insurance%20policy%20documents%20peaceful%20warm%20living%20room%20natural%20light%20soft%20bokeh%20compassionate%20planning&width=600&height=380&seq=related-burial&orientation=landscape',
  },
  'life-insurance-smokers-indiana': {
    slug: 'life-insurance-smokers-indiana',
    title: 'Life Insurance for Smokers Indiana: Real 2025 Rates',
    excerpt: 'How much more smokers pay in Indiana, which carriers are most lenient, and exactly how to qualify for the best tobacco rates.',
    category: 'Special Cases',
    categoryColor: 'bg-slate-600 text-white',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Indiana%20adult%20reviewing%20life%20insurance%20options%20on%20laptop%20at%20home%20bright%20clean%20modern%20desk%20determined%20focused%20person%20seeking%20affordable%20coverage%20despite%20smoking%20history%20warm%20light&width=600&height=380&seq=related-smokers&orientation=landscape',
  },
  'term-life-insurance-indianapolis': {
    slug: 'term-life-insurance-indianapolis',
    title: 'Term Life Insurance Indianapolis: Complete Guide',
    excerpt: 'Costs, coverage amounts, top carriers, and how to get the best rates for Indianapolis families in 2025.',
    category: 'Term Life',
    categoryColor: 'bg-[#D97642] text-white',
    readTime: '12 min read',
    image: 'https://readdy.ai/api/search-image?query=professional%20family%20sitting%20at%20table%20reviewing%20life%20insurance%20documents%20in%20bright%20modern%20Indianapolis%20home%20warm%20natural%20light%20clean%20white%20background&width=600&height=380&seq=related-term&orientation=landscape',
  },
  'best-life-insurance-indianapolis': {
    slug: 'best-life-insurance-indianapolis',
    title: 'Best Life Insurance Companies Indianapolis',
    excerpt: 'Top-rated carriers in Indianapolis ranked by price, financial strength, and customer service — 2025 edition.',
    category: 'Term Life',
    categoryColor: 'bg-[#D97642] text-white',
    readTime: '13 min read',
    image: 'https://readdy.ai/api/search-image?query=insurance%20agent%20shaking%20hands%20with%20happy%20client%20in%20bright%20modern%20office%20Indianapolis%20Indiana%20professional%20clean%20background%20warm%20lighting%20trust&width=600&height=380&seq=related-best&orientation=landscape',
  },
  'life-insurance-rates-indianapolis': {
    slug: 'life-insurance-rates-indianapolis',
    title: 'Life Insurance Rates Indianapolis: 2025 Comparison',
    excerpt: 'Exact prices by age, health class, and coverage amount — and how to get the lowest rates in Central Indiana.',
    category: 'Term Life',
    categoryColor: 'bg-[#D97642] text-white',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=calculator%20and%20insurance%20rate%20comparison%20chart%20on%20clean%20white%20desk%20minimal%20professional%20background%20Indianapolis%20life%20insurance%20pricing&width=600&height=380&seq=related-rates&orientation=landscape',
  },
  'final-expense-insurance-indianapolis': {
    slug: 'final-expense-insurance-indianapolis',
    title: 'Final Expense Insurance Indianapolis',
    excerpt: 'Everything seniors need to know about final expense coverage — costs, top carriers, and how to qualify.',
    category: 'Final Expense',
    categoryColor: 'bg-amber-600 text-white',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=senior%20couple%20sitting%20together%20reviewing%20insurance%20paperwork%20at%20kitchen%20table%20warm%20cozy%20home%20Indianapolis%20Indiana%20soft%20natural%20light%20compassionate&width=600&height=380&seq=related-finalexpense&orientation=landscape',
  },
  'business-key-person-insurance-indianapolis': {
    slug: 'business-key-person-insurance-indianapolis',
    title: 'Key Person Life Insurance Indianapolis',
    excerpt: 'How to protect your Indianapolis business from the financial impact of losing a key employee or owner.',
    category: 'Business',
    categoryColor: 'bg-[#1A3A52] text-white',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=business%20owner%20in%20modern%20Indianapolis%20office%20reviewing%20key%20person%20insurance%20documents%20professional%20clean%20background%20warm%20lighting%20executive&width=600&height=380&seq=related-keyperson&orientation=landscape',
  },
  'indexed-universal-life-indianapolis': {
    slug: 'indexed-universal-life-indianapolis',
    title: 'Indexed Universal Life Insurance Indianapolis',
    excerpt: 'Market-linked growth with downside protection, tax-free loans, and retirement income strategies for Indiana families.',
    category: 'Universal Life',
    categoryColor: 'bg-teal-600 text-white',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=stock%20market%20growth%20chart%20on%20screen%20with%20insurance%20documents%20on%20desk%20clean%20minimal%20office%20background%20warm%20tones%20IUL%20policy&width=600&height=380&seq=related-iul&orientation=landscape',
  },
  'life-insurance-new-parents-indianapolis': {
    slug: 'life-insurance-new-parents-indianapolis',
    title: 'Life Insurance for New Parents Indianapolis',
    excerpt: 'Why new parents need life insurance immediately, how much coverage you need, and how to apply quickly.',
    category: 'Family Coverage',
    categoryColor: 'bg-emerald-600 text-white',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=young%20parents%20holding%20newborn%20baby%20in%20bright%20cozy%20nursery%20Indianapolis%20Indiana%20warm%20soft%20lighting%20clean%20minimal%20background%20proud%20happy&width=600&height=380&seq=related-newparents&orientation=landscape',
  },
  'mortgage-protection-indianapolis': {
    slug: 'mortgage-protection-indianapolis',
    title: 'Mortgage Protection Insurance Indianapolis',
    excerpt: 'How mortgage protection insurance works in Indianapolis and how to keep your family\'s home safe.',
    category: 'Mortgage',
    categoryColor: 'bg-rose-600 text-white',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=family%20standing%20in%20front%20of%20beautiful%20suburban%20home%20Indianapolis%20Indiana%20sunny%20day%20green%20lawn%20clean%20white%20background%20happy%20homeowners&width=600&height=380&seq=related-mortgage&orientation=landscape',
  },
  'whole-life-insurance-indianapolis': {
    slug: 'whole-life-insurance-indianapolis',
    title: 'Whole Life Insurance Indianapolis: Permanent Coverage',
    excerpt: 'How whole life insurance provides lifetime protection and builds guaranteed cash value for Indianapolis families.',
    category: 'Whole Life',
    categoryColor: 'bg-teal-600 text-white',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=professional%20financial%20advisor%20meeting%20with%20family%20discussing%20whole%20life%20insurance%20policy%20documents%20modern%20office%20warm%20lighting%20trust%20Indianapolis%20permanent%20coverage&width=600&height=380&seq=related-wholelife&orientation=landscape',
  },
  'term-vs-whole-life-indianapolis': {
    slug: 'term-vs-whole-life-indianapolis',
    title: 'Term vs. Whole Life Insurance Indianapolis',
    excerpt: 'Side-by-side comparison of term and whole life insurance — costs, benefits, and which is right for your situation.',
    category: 'Comparison',
    categoryColor: 'bg-slate-600 text-white',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=side%20by%20side%20comparison%20chart%20showing%20term%20life%20versus%20whole%20life%20insurance%20options%20clean%20professional%20modern%20background%20financial%20planning&width=600&height=380&seq=related-termvswhole&orientation=landscape',
  },
  'wealth-building-life-insurance-indianapolis': {
    slug: 'wealth-building-life-insurance-indianapolis',
    title: 'Building Wealth with Life Insurance Indianapolis',
    excerpt: 'Tax-free growth strategies using permanent life insurance — infinite banking, retirement income, and college funding.',
    category: 'Wealth Building',
    categoryColor: 'bg-[#1A3A52] text-white',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=wealth%20building%20concept%20with%20life%20insurance%20policy%20documents%20investment%20growth%20charts%20financial%20planning%20materials%20executive%20desk%20professional%20Indianapolis&width=600&height=380&seq=related-wealthbuild&orientation=landscape',
  },
  'life-insurance-seniors-over-60-indianapolis': {
    slug: 'life-insurance-seniors-over-60-indianapolis',
    title: 'Life Insurance for Seniors Over 60 Indianapolis',
    excerpt: 'Best coverage options, real rates, and guaranteed approval policies for Indianapolis seniors aged 60–85.',
    category: 'Senior Coverage',
    categoryColor: 'bg-amber-600 text-white',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=happy%20healthy%20senior%20couple%20over%2060%20in%20Indianapolis%20Indiana%20reviewing%20insurance%20documents%20at%20home%20natural%20warm%20light%20retirement%20lifestyle%20smiling&width=600&height=380&seq=related-seniors60&orientation=landscape',
  },
  'life-insurance-diabetes-indianapolis': {
    slug: 'life-insurance-diabetes-indianapolis',
    title: 'Life Insurance with Diabetes Indianapolis',
    excerpt: 'Get approved for affordable life insurance with Type 1 or Type 2 diabetes — A1C guidelines, top carriers, and real rates.',
    category: 'Special Cases',
    categoryColor: 'bg-rose-600 text-white',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=diabetic%20person%20reviewing%20life%20insurance%20application%20forms%20at%20home%20with%20glucose%20meter%20on%20desk%20warm%20natural%20light%20hopeful%20confident%20clean%20minimal%20background&width=600&height=380&seq=related-diabetes&orientation=landscape',
  },
  'life-insurance-high-blood-pressure': {
    slug: 'life-insurance-high-blood-pressure',
    title: 'Life Insurance with High Blood Pressure Indiana',
    excerpt: 'Approval guide for Indiana residents with hypertension — BP guidelines by carrier, approval tips, and real rate impact.',
    category: 'Special Cases',
    categoryColor: 'bg-rose-600 text-white',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=Indiana%20person%20with%20blood%20pressure%20monitor%20reviewing%20life%20insurance%20documents%20at%20home%20confident%20determined%20clean%20minimal%20background%20natural%20light%20health%20management&width=600&height=380&seq=related-highbp&orientation=landscape',
  },
  'universal-life-insurance-indianapolis': {
    slug: 'universal-life-insurance-indianapolis',
    title: 'Universal Life Insurance Indianapolis',
    excerpt: 'Flexible premiums and adjustable death benefits — how universal life works and who it\'s best for in Indianapolis.',
    category: 'Universal Life',
    categoryColor: 'bg-teal-600 text-white',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=professional%20insurance%20agent%20explaining%20universal%20life%20insurance%20flexible%20premium%20options%20Indianapolis%20modern%20consultation%20room%20charts%20clean%20background&width=600&height=380&seq=related-universallife&orientation=landscape',
  },
  'annuities-retirement-indianapolis': {
    slug: 'annuities-retirement-indianapolis',
    title: 'Annuities for Retirement Indianapolis',
    excerpt: 'Guaranteed lifetime income you can\'t outlive — how annuities work, types compared, and who benefits most.',
    category: 'Retirement',
    categoryColor: 'bg-teal-600 text-white',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=senior%20couple%20reviewing%20annuity%20retirement%20income%20plan%20with%20advisor%20comfortable%20Indianapolis%20office%20warm%20lighting%20guaranteed%20income%20planning%20documentation&width=600&height=380&seq=related-annuities&orientation=landscape',
  },
  'life-insurance-private-pilots': {
    slug: 'life-insurance-private-pilots',
    title: 'Life Insurance for Private Pilots Indiana',
    excerpt: 'How aviation impacts your life insurance application, which carriers are pilot-friendly, and how to get approved.',
    category: 'Special Cases',
    categoryColor: 'bg-slate-600 text-white',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=private%20pilot%20in%20small%20aircraft%20cockpit%20Indiana%20sky%20aviation%20life%20insurance%20concept%20professional%20confident%20clean%20background%20warm%20tones&width=600&height=380&seq=related-pilots&orientation=landscape',
  },
  'life-insurance-stay-at-home-parents-indiana': {
    slug: 'life-insurance-stay-at-home-parents-indiana',
    title: 'Life Insurance for Stay-at-Home Parents Indiana',
    excerpt: 'Indiana SAHPs provide $92K+ in annual household services. Why you need $500K–$1M in coverage and how to get it for under $30/month.',
    category: 'Family Coverage',
    categoryColor: 'bg-emerald-600 text-white',
    readTime: '12 min read',
    image: 'https://readdy.ai/api/search-image?query=stay%20at%20home%20parent%20Indiana%20mom%20playing%20with%20two%20young%20children%20in%20bright%20sunny%20living%20room%20warm%20natural%20light%20cozy%20family%20home%20clean%20minimal%20background%20loving%20nurturing%20scene&width=600&height=380&seq=related-sahp&orientation=landscape',
  },
};

// Comprehensive topical cluster RELATED_MAP for all 27 articles
const RELATED_MAP: Record<string, string[]> = {
  // Coverage Planning cluster — Pillar: how-much-life-insurance-indiana
  'how-much-life-insurance-indiana': ['life-insurance-for-families-indianapolis', 'cheapest-life-insurance-indiana', 'life-insurance-rates-indianapolis'],
  'life-insurance-for-families-indianapolis': ['how-much-life-insurance-indiana', 'life-insurance-stay-at-home-parents-indiana', 'life-insurance-new-parents-indianapolis'],
  'life-insurance-new-parents-indianapolis': ['how-much-life-insurance-indiana', 'life-insurance-stay-at-home-parents-indiana', 'life-insurance-for-families-indianapolis'],

  // Stay-at-home parents
  'life-insurance-stay-at-home-parents-indiana': ['life-insurance-for-families-indianapolis', 'life-insurance-new-parents-indianapolis', 'how-much-life-insurance-indiana'],

  // Term Life cluster — Pillar: term-life-insurance-indianapolis
  'term-life-insurance-indianapolis': ['how-much-life-insurance-indiana', 'term-vs-whole-life-indianapolis', 'no-medical-exam-life-insurance-indiana'],
  'term-vs-whole-life-indianapolis': ['term-life-insurance-indianapolis', 'whole-life-insurance-indianapolis', 'indexed-universal-life-indianapolis'],
  'best-life-insurance-indianapolis': ['life-insurance-rates-indianapolis', 'how-much-life-insurance-indiana', 'term-life-insurance-indianapolis'],
  'life-insurance-rates-indianapolis': ['term-life-insurance-indianapolis', 'cheapest-life-insurance-indiana', 'how-much-life-insurance-indiana'],
  'cheapest-life-insurance-indiana': ['how-much-life-insurance-indiana', 'no-medical-exam-life-insurance-indiana', 'life-insurance-rates-indianapolis'],
  'life-insurance-quotes-indiana': ['cheapest-life-insurance-indiana', 'how-much-life-insurance-indiana', 'best-life-insurance-indianapolis'],

  // Mortgage/Home cluster
  'mortgage-protection-indianapolis': ['term-life-insurance-indianapolis', 'how-much-life-insurance-indiana', 'life-insurance-for-families-indianapolis'],

  // Permanent Life cluster — Pillar: whole-life-insurance-indianapolis
  'whole-life-insurance-indianapolis': ['term-vs-whole-life-indianapolis', 'indexed-universal-life-indianapolis', 'wealth-building-life-insurance-indianapolis'],
  'indexed-universal-life-indianapolis': ['whole-life-insurance-indianapolis', 'wealth-building-life-insurance-indianapolis', 'life-insurance-self-employed-indiana'],
  'universal-life-insurance-indianapolis': ['whole-life-insurance-indianapolis', 'indexed-universal-life-indianapolis', 'term-vs-whole-life-indianapolis'],
  'wealth-building-life-insurance-indianapolis': ['indexed-universal-life-indianapolis', 'whole-life-insurance-indianapolis', 'term-vs-whole-life-indianapolis'],
  'annuities-retirement-indianapolis': ['wealth-building-life-insurance-indianapolis', 'indexed-universal-life-indianapolis', 'life-insurance-seniors-over-60-indianapolis'],

  // Seniors/Final Expense cluster — Pillar: life-insurance-indiana-seniors
  'life-insurance-indiana-seniors': ['burial-insurance-indiana', 'final-expense-insurance-indianapolis', 'no-medical-exam-life-insurance-indiana'],
  'life-insurance-seniors-over-60-indianapolis': ['burial-insurance-indiana', 'final-expense-insurance-indianapolis', 'life-insurance-indiana-seniors'],
  'final-expense-insurance-indianapolis': ['burial-insurance-indiana', 'life-insurance-indiana-seniors', 'no-medical-exam-life-insurance-indiana'],
  'burial-insurance-indiana': ['final-expense-insurance-indianapolis', 'life-insurance-indiana-seniors', 'life-insurance-seniors-over-60-indianapolis'],

  // No Exam cluster
  'no-medical-exam-life-insurance-indiana': ['cheapest-life-insurance-indiana', 'life-insurance-indiana-seniors', 'burial-insurance-indiana'],

  // Special Cases cluster
  'life-insurance-smokers-indiana': ['no-medical-exam-life-insurance-indiana', 'cheapest-life-insurance-indiana', 'how-much-life-insurance-indiana'],
  'life-insurance-diabetes-indianapolis': ['life-insurance-high-blood-pressure', 'no-medical-exam-life-insurance-indiana', 'best-life-insurance-indianapolis'],
  'life-insurance-high-blood-pressure': ['life-insurance-diabetes-indianapolis', 'no-medical-exam-life-insurance-indiana', 'best-life-insurance-indianapolis'],
  'life-insurance-private-pilots': ['no-medical-exam-life-insurance-indiana', 'term-life-insurance-indianapolis', 'how-much-life-insurance-indiana'],

  // Business/Self-Employed cluster
  'life-insurance-self-employed-indiana': ['how-much-life-insurance-indiana', 'business-key-person-insurance-indianapolis', 'indexed-universal-life-indianapolis'],
  'business-key-person-insurance-indianapolis': ['life-insurance-self-employed-indiana', 'term-life-insurance-indianapolis', 'indexed-universal-life-indianapolis'],
};

const DEFAULT_RELATED = ['how-much-life-insurance-indiana', 'cheapest-life-insurance-indiana', 'life-insurance-for-families-indianapolis'];

interface BlogRelatedStripProps {
  currentSlug: string;
}

export default function BlogRelatedStrip({ currentSlug }: BlogRelatedStripProps) {
  const relatedSlugs = RELATED_MAP[currentSlug] ?? DEFAULT_RELATED;
  const articles = relatedSlugs
    .filter(s => s !== currentSlug)
    .slice(0, 3)
    .map(s => ARTICLE_DATA[s])
    .filter(Boolean) as RelatedArticle[];

  if (articles.length === 0) return null;

  return (
    <section className="py-14 bg-[#F7F9FB]">
      <div className="max-w-5xl mx-auto px-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#D97642] mb-1">Keep Reading</p>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1A3A52]">Related Articles</h2>
          </div>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#1A3A52] hover:text-[#D97642] transition-colors whitespace-nowrap cursor-pointer"
          >
            View All 27 Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Cards */}
        <div className="grid sm:grid-cols-3 gap-6">
          {articles.map(article => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#D97642]/30 transition-all duration-300 flex flex-col cursor-pointer"
            >
              {/* Thumbnail */}
              <div className="w-full h-[180px] overflow-hidden flex-shrink-0 relative">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  loading="lazy"
                  decoding="async"
                  width={600}
                  height={380}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className={`absolute top-3 left-3 text-[11px] font-bold px-2.5 py-1 rounded-full ${article.categoryColor}`}>
                  {article.category}
                </span>
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-bold text-[#1A3A52] text-[15px] leading-snug mb-2 group-hover:text-[#D97642] transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-[13px] text-gray-500 leading-relaxed flex-1 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-100">
                  <span className="text-[11px] text-gray-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>{article.readTime}
                  </span>
                  <span className="text-[12px] font-semibold text-[#D97642] flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read <i className="ri-arrow-right-line text-[13px]"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
